<form [formGroup]="tagForm">
  <div id="tag-array" formArrayName="tagFormArray">
    @for (tagPair of tagForm.value.tagFormArray; track tagTrackBy(i, tagPair); let i = $index) {
      <div class="flex-center-row tag-row" [formGroupName]="i">
        <input id="tag-name" class="arpio-input tag-input" type="text" formControlName="tagName" placeholder="Tag" />
        <div class="has-value-div">with value</div>
        <input
          id="tag-value"
          class="arpio-input tag-input"
          type="text"
          formControlName="tagValue"
          placeholder="Value"
        />
        <div class="flex-center-column remove-button-div">
          @if (tagPair.tagName.length > 0) {
            <button class="remove-button" (click)="removeTagAt(i)">
              <svg lucideX></svg>
            </button>
          }
        </div>
      </div>
    }
  </div>
</form>
